export default "__VITE_ASSET__0e786551__"